import React from "react";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftLongLine } from "react-icons/ri";
const LeftArrowIcon = RiArrowLeftLongLine as React.FC<any>;

interface BackBtnType {
  route?: string | null;
}

const BackButton = ({ route = null }: BackBtnType) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // If browser has previous page
    if (window.history.length > 1) {
      navigate(-1);
    } else if (route) {
      // fallback
      navigate(route);
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      className="btn btn-tertiary text-white d-flex align-items-center py-1"
    >
      <LeftArrowIcon className="me-2" />
      Back
    </button>
  );
};

export default BackButton;

// import React from "react";
// import { useNavigate } from "react-router";
// import { Link } from "react-router-dom";
// import { all_routes } from "../../feature-module/router/all_routes";
// import { RiArrowLeftLongLine } from "react-icons/ri";

// interface BackBtnType {
//   route: string | null;
// }
// const LeftArrowIcon = RiArrowLeftLongLine as React.FC<any>;

// const BackButton = ({ route = null }: BackBtnType) => {
//   return (
//       <Link
//         to={route || "#"}
//         className="btn btn-tertiary text-white d-flex align-items-center py-1"
//       >
//         <LeftArrowIcon className="me-2" /> Back
//       </Link>
//   );
// };

// export default BackButton;
